import { useMutation } from 'react-query';
import { queryClient } from '../../../../../config/queryClient';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../../../CommonUtils/urlWithParams';
import { queryKeys } from '../../pages/AssetBucketingResults/api/queryKeys';

export interface DeleteWhatIfParams {
  clientId: number;
  fpId: string;
  goalId?: string;
  whatIfKey: string;
}

const deleteWhatIf = ({ clientId, fpId, goalId, whatIfKey }: DeleteWhatIfParams): Promise<null> =>
  authFetch(
    urlWithParams('/Consumer/FinancialPlanWhatIfs/RemoveWhatIfs', {
      clientId,
      fpId,
      goalId,
    }),
    {
      method: 'POST',
      ...httpBodyOptions(
        {
          WhatIfsKeys: [whatIfKey],
        },
        true,
      ),
    },
  );

export const useDeleteWhatIfMutation = () => {
  return useMutation(deleteWhatIf, {
    async onSuccess(_, { clientId, fpId }) {
      await queryClient.invalidateQueries(queryKeys.AssetBucketing(clientId, fpId));
    },
  });
};
